
import "./SkillCard.css";

export default function SkillCard({ skill, setActionEvent }) {
 


  return (
    <div className="skill-card" onClick={()=>{
        
       setActionEvent({
        nameEvent:"skillCard",
        data:skill
       })
    }}>
      <img src={skill.cover} alt={skill.name} className="skill-card-cover" />
      <div className="skill-card-content">
        <h2 className="skill-card-title">{skill.name}</h2>
        <p className="skill-card-description">{skill.description}</p>
      </div>
    </div>
  );
}